import { z } from 'zod';

/** Курсорная пагинация (AGENTS.md §3.8). */
export const cursorQuerySchema = z
  .object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
  })
  .strict();

export type CursorQuery = z.infer<typeof cursorQuerySchema>;

export const idParamSchema = z.object({ id: z.string().min(1) }).strict();

/** Email нормализуется везде одинаково (AGENTS.md §3.10). */
export const emailSchema = z.string().trim().toLowerCase().email('Укажите корректный адрес почты');

export const passwordSchema = z.string().min(8, 'Пароль должен быть не короче 8 символов').max(128);

/**
 * Продуктовая фраза, которую собирает сервер (§22, §31).
 *
 * Сервер один, а языков десять, поэтому наружу уходит код и подстановки —
 * переводит клиент. Текст остаётся запасным: код, которого клиент ещё не знает,
 * покажется как есть, а не пропадёт.
 */
export interface Notice {
  code: string;
  params?: Record<string, string | number>;
  /** Текст на языке сервера. Показывается, если перевода по коду нет. */
  message: string;
}
